import {
  Ionicons,
  MaterialIcons,
  MaterialCommunityIcons,
  AntDesign,
} from "@expo/vector-icons";
import {
  MODERN_CHART_COLORS
} from "@utils/chartTheme";

export type WidgetKey =
  | "welcome"
  | "messages"
  | "calendar"
  | "invitations"
  | "team"
  | "dataChart"
  | "usageStat"
  | "usageDonut"
  | "activityLine"
  | "usagePie"
  | "progress"
  | "monthly"
  | "performance"
  | "subscription";

export type WidgetSize = "small" | "medium" | "large";

export const SIZE_CONFIG: Record < WidgetSize, number > = {
  small: 200,
  medium: 300,
  large: 420,
};

export const DEFAULT_WIDGET_ORDER: WidgetKey[] = [
  "welcome",
  "messages",
  "calendar",
  "invitations",
  "team",
  "dataChart",
  "usageStat",
  "usageDonut",
  "activityLine",
  "usagePie",
  "progress",
  "monthly",
  "performance",
  "subscription",
];

export const WIDGET_CONFIGS = {
  messages: {
    icon: Ionicons,
    name: "mail-unread",
    color: "white",
    label: "Messages",
    backgroundColor: "#4CAF50",
  },
  calendar: {
    icon: MaterialIcons,
    name: "system-update-alt",
    color: "white",
    label: "Updates",
    backgroundColor: "#2196F3",
  },
  invitations: {
    icon: MaterialCommunityIcons,
    name: "newspaper-plus",
    color: "white",
    label: "Invites",
    backgroundColor: "#FF9800",
  },
  team: {
    icon: AntDesign,
    name: "team",
    color: "white",
    label: "Team Members",
    backgroundColor: "#9C27B0",
  },
};

export const USAGE_PIE_CHART_COLORS = {
  primary: MODERN_CHART_COLORS.pie.primary,
  secondary: MODERN_CHART_COLORS.pie.secondary,
  tertiary: MODERN_CHART_COLORS.pie.tertiary,
  quaternary: MODERN_CHART_COLORS.pie.quaternary,
};
